import { render, staticRenderFns } from "./ScaleListPlugin.vue?vue&type=template&id=2a85a7c0&scoped=true"
import script from "./ScaleListPlugin.vue?vue&type=script&lang=ts"
export * from "./ScaleListPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ScaleListPlugin.vue?vue&type=style&index=0&id=2a85a7c0&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2a85a7c0",
  null
  ,true
)

export default component.exports